import { weeksCount } from './getWeekCountBetweenDates';
import { getNearestSunday, getWeekAfterStartDate, updateAllData } from './';
import updateWeekNumbers from './updateWeekNumbers';
import { rebuildSubjectsArray } from './addNewMilestone';
import { getWeekIndex, isTestPresentInArray } from '../../coursePlan/addTestDialog/AddScheduledTestOnGoals/helpers';

interface NewDetailsType {
  name: string;
  startDate: Date;
  endDate: Date;
  isRevision: boolean;
}

export const updatePhaseDetails = (
  tree: any,
  setTreeData: Function,
  phaseIndex: number,
  newDetails: NewDetailsType
) => {
  const cloneTree = JSON.parse(JSON.stringify(tree));
  const { phases } = tree;
  let clonePhases = JSON.parse(JSON.stringify(phases));
  const currentPhase = clonePhases[phaseIndex];
  currentPhase.name = newDetails.name.trim();
  currentPhase.startDate = newDetails.startDate;
  currentPhase.endDate = newDetails.endDate;
  currentPhase.isRevision = newDetails.isRevision;

   // Validate conflict resolution
  if(currentPhase.hasOwnProperty('conflict')){
    validateConflictResolution(currentPhase, phaseIndex, tree);
  }
let mainTests:any[] = []
  const weeksLength = currentPhase.weeks.length;
  if (currentPhase.weeks && weeksLength) {
    mainTests = redistributeChapters(currentPhase, tree.weekFormat);
  }
  updateDates(currentPhase, tree.weekFormat);

  if (mainTests.length) {
    distributeMainTests(currentPhase.weeks, mainTests);
}
  updateWeekNumbers(clonePhases);
  rebuildSubjectsArray(currentPhase);
  
  cloneTree.phases = clonePhases;
  setTreeData({ treeData: cloneTree  });
};

  // Validate conflict resolution
const validateConflictResolution = (currentPhase: any, phaseIndex: number, tree: any) => {
  const { phases } = tree;
  let clonePhases = JSON.parse(JSON.stringify(phases));
  const prevStart = new Date(clonePhases[phaseIndex].startDate).getTime();
  const prevEnd = new Date(clonePhases[phaseIndex].endDate).getTime();
  const currentStart = new Date(currentPhase.startDate).getTime();
  const currentEnd = new Date(currentPhase.endDate).getTime();

  const hasProperStartDate = currentStart !== prevStart;
  const hasProperEndDate = currentEnd !== prevEnd;

  if (hasProperStartDate && hasProperEndDate) {
    currentPhase.conflict = false;
  }
};


export const redistributeChapters = (clonePhase: any, weekFormat: string) => {
  const weeksLength = clonePhase.weeks.length;
  const numberOfWeeks = weeksCount(clonePhase.startDate, clonePhase.endDate, weekFormat);
  // if unequal then redistribute content within phase
  if (numberOfWeeks !== weeksLength) {
    //collect all subjects and chapters
    const subjectWiseChapters = collectChapters(clonePhase.weeks);
    const mainTests = collectMainTests(clonePhase.weeks);
    //create new weeks array
    const newWeeks = createNewWeeks(clonePhase, numberOfWeeks);
   
    //divide each subject equally between all weeks
    clonePhase.weeks = distributeChapters(newWeeks, subjectWiseChapters);
    if (mainTests.length) {
      return mainTests;
    }
  }
  return [];
};


const collectMainTests = (weeks: any) => {
  let mainTests:any[] = [];
  for (const week of weeks) {
    if (week.content.length) {
      const content = JSON.parse(JSON.stringify(week.content))
      mainTests = [...mainTests, ...content];
    }
  }
  console.log({mainTests})
  return mainTests;
}

const distributeMainTests = (weeks: any, mainTests: any) => {
  for (const test of mainTests) {
    let weekIndex = getWeekIndex(test.startDate, weeks);
    console.log({test, weekIndex})
    if (!(weekIndex === -1) && !isTestPresentInArray(test.name, weeks[weekIndex].content)){
      weeks[weekIndex].content.push(test);
   }
}
}

const createNewWeeks = (clonePhase: any, numberOfWeeks: number) => {
  const weekTemplate = JSON.parse(JSON.stringify(clonePhase.weeks[0]));
  weekTemplate.content = [];
  weekTemplate.subjects = [];
  const newWeeks = [];
  // array of new weeks
  for (let i = 0; i < numberOfWeeks; i++) {
    newWeeks.push(JSON.parse(JSON.stringify(weekTemplate)));
  }

  return newWeeks;
};

export const distributeChapters = (newWeeks: any, subjectWiseChapters: any) => {
  const numberOfWeeks = newWeeks.length;
  const subjChapPerWeek: { [k: string]: number } = {};

  subjectWiseChapters.forEach((subject: any) => {
    const name = subject.name;
    const count = Math.floor(subject.chapters.length / numberOfWeeks);

    subjChapPerWeek[name] = count <= 0 ? 1 : count; //which subject to divide into how many chapters per week
  });

  // distribute chapters
  for (const subject of subjectWiseChapters) {
    const name = subject.name;
    const count = subjChapPerWeek[name];

    for (let i = 0; i < numberOfWeeks; i++) {
      // for (const week of newWeeks) {
      const newSubjectObj = JSON.parse(JSON.stringify(subject));
      if (i !== numberOfWeeks - 1 && subject.chapters.length) {
        //if this is not last week then don't add all chapters
        const chapters = subject.chapters.splice(0, count);
        newSubjectObj.chapters = chapters;
      }
      newWeeks[i].subjects.push(newSubjectObj);
    }
  }
  return newWeeks;
};

export const collectChapters = (weeks: any) => {
  const subjectWiseChapters = JSON.parse(JSON.stringify(weeks[0].subjects));
  const weeksLength = weeks.length;
  // iterate over every and every subjects and collect their chapters
  for (let i = 1; i < weeksLength; i++) {
    weeks[i].subjects.forEach((subject: any) => {
      let foundSubject = false;

      for (const sub of subjectWiseChapters) {
        if (subject.name === sub.name) {
          sub.chapters = [...JSON.parse(JSON.stringify(sub.chapters)), ...JSON.parse(JSON.stringify(subject.chapters))];
          foundSubject = true;
        }
      }

      if (!foundSubject) {
        //if subject was not found in subjectWiseChpaters array
        subjectWiseChapters.push(JSON.parse(JSON.stringify(subject)));
      }
    });
  }
  return subjectWiseChapters;
};

const updateDates = (currentPhase: any, weekFormat: string) => {
  let { startDate } = currentPhase;

  // if week format is 'weekly'
  if (weekFormat === 'weekly') {
    currentPhase.weeks.forEach((week: any) => {
      week.startDate = startDate;
      const endDate = getWeekAfterStartDate(startDate);
      week.endDate = getWeekAfterStartDate(startDate);
      startDate = new Date(endDate.setDate(endDate.getDate() + 1));
    });
  } else {
    // if week format is monday-to-sunday
    currentPhase.weeks.forEach((week: any) => {
      week.startDate = startDate;
      const endDate = getNearestSunday(startDate);
      week.endDate = getNearestSunday(startDate);
      startDate = new Date(endDate.setDate(endDate.getDate() + 1));
    });
  }

  //if endDate of last week extends the endDate of phase
  const lastWeek = currentPhase.weeks[currentPhase.weeks.length - 1];
  const endDate = new Date(lastWeek.endDate);
  if (endDate.getTime() > new Date(currentPhase.endDate).getTime()) {
    currentPhase.weeks[currentPhase.weeks.length - 1].endDate = new Date(currentPhase.endDate);
  }
};
